<div class="cdp-warn-chip-container">
    <hc-chip color="yellow" width="100%">
        <div class="cdp-warn-message-container">
            <hc-icon class="icon-warn" hcIconSm></hc-icon>
            <div>
                If you continue, one or more jobs will be reassigned to a new schedule.
                <span
                    class="icon-info cdp-info-ico icon-right"
                    hcTooltip="Jobs can only be assigned to one schedule. Jobs that were previously assigned to another schedule will be reassigned to this one."
                ></span>
            </div>
        </div>
    </hc-chip>
</div>
